import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { withRouter } from 'react-router-dom';
import { CloseButton, Modal } from 'lib/components';
import VideoUpload, { View } from '../videoUpload/VideoUpload';

const ModalItem = styled.div`
  display: block;
  position: relative;
  width: 592px;
  height: 580px;
  overflow: hidden;
  background-color: #fff;
`;

export const ModalUpload = withRouter((props: any) => {
  const { disabled = false, handleModalClose, targetFolder } = props;
  const [canceling, setCanceling] = useState(false);
  const [progress, setProgress] = useState(View.FORM);

  const handleClose = () => {
    if (progress === View.FORM) {
      return handleModalClose();
    }
    setCanceling(true);
  };
  const disableCancel = progress === View.CREATE || progress === View.ENCODE;

  return (
    <Modal>
      <ModalItem>
        <CloseButton disabled={disabled} zIndex={true} onClick={handleClose} />
        <VideoUpload
          handleModalClose={handleModalClose}
          progress={progress}
          setProgress={setProgress}
          canceling={canceling}
          contentStyle={{
            body: {
              maxHeight: '440px',
              minHeight: '440px',
            },
            inputLabel: {
              left: '0',
            },
            footer: {
              position: 'inherit',
              width: '100%',
              marginTop: '0',
            },
          }}
          noButtonPadding
          setCanceling={setCanceling}
          disableCancel={disableCancel}
          targetFolder={targetFolder}
        />
      </ModalItem>
    </Modal>
  );
});
